import Image from "next/image"
import rencontreunarchi from "../../../public/rencontreunarchilogo.png";
import kube from "../../../public/kubelogo.png";
import avatar from "../../../public/avatar1.png";
import avatar2 from "../../../public/avatar2.png";

function Customer(){
    return(
        <div id='client' className="bg-[#CCDDEE] flex justify-center items-center flex-col py-[120px] select-none text-[#042040]">
            <h4 className="text-4xl font-bold tracking-tight text-center text-[#042040] sm:text-5xl mx-10">
             Nos clients témoignent
            </h4>

            <div className="mt-10 flex flex-wrap justify-center items-center gap-20 my-15 md:my-20">
                <div className="bg-white w-[320px] md:w-[520px] min-h-[500px] rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] ease-in duration-500 text-center px-5 py-4 shadow-[10px_10px_0px_#FED90F] hover:shadow-none flex flex-col justify-start items-start">
                    
                    <a
                        href="https://www.rencontreunarchi.com/"
                        target='_blank'
                        rel="noopener noreferrer"
                        className="mx-auto"
                    >
                        <Image src={rencontreunarchi} height={65} alt='rencontreunarchi logo'/>
                    </a>
                    

                    <p className="text-left mt-2 px-3 py-5">Depuis deux ans, l&apos;intervention de heelio en tant que DAF à temps partiel a radicalement transformé notre approche de la gestion financière. Le suivi rigoureux de la trésorerie et de la facturation nous a permis de nous concentrer sur notre cœur de métier sans tracas financiers. 
                    <br></br>Le prévisionnel et le reporting investisseur sont devenus des outils précis et fiables qui renforcent la confiance avec nos partenaires financiers. C&apos;est un soulagement d&apos;avoir à nos côtés un expert qui comprend tant le métier que les chiffres.</p>

                    <div className="grow px-3 flex justify-start items-center space-x-5">
                        <Image src={avatar} width="70" alt='rencontreunarchi fondateur' className="rounded-full border-[#FED90F] border-4"/>
                        <div>
                            <p className="text-left font-bold text-sm md:text-base">
                                <a 
                                    href="https://www.linkedin.com/in/doroth%C3%A9e-simon-0506b749/"
                                    target='_blank'
                                    rel="noopener noreferrer"
                                >
                                Dorothée Simon
                                </a>
                            </p>
                            <p className="text-sm md:text-base text-left">Cofondatrice et CEO de rencontreunarchi - <span className="font-bold">Marketplace</span></p>
                        </div>
                    </div>
                    
                
                </div>

                <div className="bg-white w-[320px] md:w-[520px] min-h-[500px] rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] ease-in duration-500 text-center px-5 py-4 shadow-[10px_10px_0px_#FED90F] hover:shadow-none flex flex-col justify-start items-start">

                <a
                        href="https://www.lakube.com/"
                        target='_blank'
                        rel="noopener noreferrer"
                        className="mx-auto"
                    >
                        <Image src={kube} alt='modeo logo'/>
                    </a>
                    
                    

                    <p className="text-left mt-5 px-3 py-5">Avant, le suivi financier me prenait des jours et j&apos;avais des doutes sur la fiabilité de mes chiffres. Depuis plus de 2 ans avec heelio, tout a changé. Après quelques semaines de travail rigoureux, nous avons un prévisionnel extrêmement fiable. <br></br><br></br>Je peux maintenant me concentrer sur le développement de l&apos;entreprise, en toute confiance. Le volet financier est entre des mains expertes et les outils fournis (logiciel ou Excel) sont top.</p>

                    <div className="grow px-3 flex justify-self-start items-center space-x-5">
                        <Image src={avatar2} width="70" alt='modeo fondateur' className="rounded-full border-[#FED90F] border-4"/>
                        <div>
                            <p className="text-left font-bold text-sm md:text-base">
                                <a 
                                    href="https://www.linkedin.com/in/samuel-cimamonti-2b588862/" 
                                    target='_blank'
                                    rel="noopener noreferrer"
                                >
                                Samuel Cimamonti
                                </a>
                            </p>
                            <p className="text-sm md:text-base text-left">Fondateur Kube - <span className="font-bold">E-commerce</span></p>
                        </div>
                    </div>
                    
                
                </div>
            </div>
            
        </div>
    )
}

export default Customer